{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "",
    "{amount} off": "",
    "{amount} off for first {number} months.": "",
    "{amount} off for first {period}.": "",
    "{amount} off forever.": "",
    "{discount}% discount": "{discount}% chegirma",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "",
    "{memberEmail} will no longer receive this newsletter.": "",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} kun bepul",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Hisob",
    "Account details updated successfully": "",
    "Account settings": "Hisob sozlamalari",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Bepul sinov muddati tugagandan so'ng, siz tanlagan daraja uchun odatdagi narxdan undiriladi. Undan oldin istalgan vaqtda bekor qilishingiz mumkin.",
    "Already a member?": "Allaqachon a'zomisiz?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "",
    "Back": "Orqaga",
    "Back to Log in": "Kirish sahifasiga qaytish",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Cancel anytime.": "",
    "Cancel subscription": "Obunani bekor qilish",
    "Canceled": "",
    "Cancellation reason": "Bekor qilish sababi",
    "Change": "",
    "Change plan": "",
    "Check spam & promotions folders": "",
    "Check with your mail provider": "",
    "Check your inbox to verify email update": "",
    "Choose": "",
    "Choose a different plan": "Boshqa rejani tanlang",
    "Choose a plan": "",
    "Choose your newsletters": "Pochta xabarlarini tanlang",
    "Click here to retry": "",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Yopmoq",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Izohlar",
    "Complimentary": "",
    "Confirm": "Tasdiqlamoq",
    "Confirm cancellation": "",
    "Confirm subscription": "",
    "Contact support": "",
    "Continue": "Davom etmoq",
    "Continue subscription": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "",
    "Could not update email! Invalid link.": "",
    "Create a new contact": "",
    "Current plan": "",
    "Delete account": "Hisobni o'chirmoq",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "",
    "Don't have an account?": "Hisobingiz yoqmi?",
    "Edit": "",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email newsletter": "",
    "Email newsletter settings updated": "",
    "Email preferences": "Email sozlamalari",
    "Email preferences updated.": "",
    "Emails": "Elektron xatlar",
    "Emails disabled": "Elektron pochta xabarlari o‘chirilgan",
    "Ends {offerEndDate}": "",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "",
    "Expires {expiryDate}": "",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "",
    "Free Trial – Ends {trialEnd}": "",
    "Get help": "Yordam olmoq",
    "Get in touch for help": "",
    "Get notified when someone replies to your comment": "Kimdir sharhingizga javob bersa, bildirishnoma oling",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Ushbu post haqida fikr bildiring",
    "Help! I'm not receiving emails": "",
    "Here are a few other sites you may enjoy.": "",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Kirish havolasi email pochtangizga yuborildi. Agar u 3 daqiqada kelmasa, spam bo'limini tekshiring",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Bu kabi kamroq",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "",
    "Manage": "Boshqarmoq",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "Oylik",
    "More like this": "Ko'proq shunga o'xshash",
    "More options": "",
    "Name": "Ism",
    "Need more help? Contact support": "",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Elektron xatlar olmayapsizmi?",
    "Now check your email!": "Endi elektron pochtangizni tekshiring!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "",
    "Phone number": "",
    "Plan": "",
    "Plan checkout was cancelled.": "",
    "Plan upgrade was cancelled.": "",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "",
    "Podcasts": "",
    "Re-enable emails": "Elektron pochta xabarlarini qayta yoqing",
    "Recommendations": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "",
    "Resume subscription": "",
    "Retry": "Qayta urinmoq",
    "Save": "Saqlamoq",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Kirish havolasi yuborilmoqda...",
    "Sending...": "Yuborilmoqda...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "",
    "Sign in": "Kirish",
    "Sign out": "",
    "Sign up": "Ro'yxatdan o'tmoq",
    "Signup error: Invalid link": "",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "",
    "Spam complaints": "",
    "Start {amount}-day free trial": "{amount}-kun sinov muddatini boshlang",
    "Starting {startDate}": "",
    "Starting today": "",
    "Submit feedback": "Izoh yuboring",
    "Subscribe": "",
    "Subscribed": "",
    "Subscription plan updated successfully": "",
    "Success": "",
    "Success! Check your email for magic link to sign-in.": "",
    "Success! Your account is fully activated, you now have access to all content.": "",
    "Success! Your email is updated.": "",
    "Successfully unsubscribed": "Obuna muvaffaqiyatli bekor qilindi",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Izoh uchun rahmat!",
    "That didn't go to plan": "Bu rejaga mos kelmadi",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "",
    "There was a problem submitting your feedback. Please try again a little later.": "",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Bu saytda faqat taklif qilinadi, kirish uchun egasiga murojaat qiling.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Ro‘yxatdan o‘tishni yakunlash uchun pochta qutingizdagi tasdiqlash havolasini bosing. Agar u 3 daqiqada kelmasa, spam jildini tekshiring!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "",
    "Unsubscribe from all emails": "Barcha elektron pochta xabarlariga obunani bekor qiling",
    "Unsubscribed": "",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Elektron pochtalarga obunani bekor qilish {title}ga pulli obunanu bekor qilmaydi",
    "Update": "",
    "Update your preferences": "Sozlamalarni yangilash",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "",
    "Verifying...": "",
    "View plans": "",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Email manzili topilmagani uchun obunangizni bekor qila olmadik. Iltimos, sayt egasi bilan bog'laning.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "",
    "Welcome back!": "",
    "Welcome to {siteTitle}": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "",
    "Why has my email been disabled?": "",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Yillik",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "",
    "You have been successfully resubscribed": "Siz muvaffaqiyatli qayta obuna bo'ldingiz",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "",
    "You're not receiving emails": "",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Siz e-pochta xabarlarini olmayapsiz, chunki siz oxirgi xabarni spam deb belgilagansiz yoki xabarlar taqdim etilgan elektron pochta manzilingizga yetkazilmagan.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Sizning hisobingiz",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "",
    "Your subscription will renew on {renewalDate}": "",
    "Your subscription will start on {subscriptionStart}": ""
}
